import { Component } from '@angular/core';

@Component({
  selector: 'app-workshops',
  templateUrl: './workshops.component.html',
  styleUrl: './workshops.component.css'
})
export class Workshops25Component {

}
